import "normalize.css/normalize.css";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { Buttons } from "./sections/Buttons";
import { Colors } from "./sections/Colors";
import { Forms } from "./sections/Forms";
import { HeroComponent } from "./sections/HeroComponent";
import { Icons } from "./sections/Icons";
import { Lists } from "./sections/Lists";
import { Login } from "./sections/Login";
import { Modals } from "./sections/Modals";
import { NavbarDemo, NavbarSection } from "./sections/NavbarSection";
import { Popovers } from "./sections/Popovers";
import { SearchDemo, SearchSection } from "./sections/SearchSection";
import { Time } from "./sections/Time";
import { Tooltips } from "./sections/Tooltips";
import { Typography } from "./sections/Typography";
import { Units } from "./sections/Units";
import { Widgets } from "./sections/Widgets";
import { StyleguideFrame } from "./StyleguideFrame";

const framed = (Component) => (
  <StyleguideFrame>
    <Component />
  </StyleguideFrame>
);

export const routes = ({ match: { path } }) => (
  <Switch>
    <Route path={`${path}/colors`} render={() => framed(Colors)} />
    <Route path={`${path}/buttons`} render={() => framed(Buttons)} />
    <Route path={`${path}/modals`} render={() => framed(Modals)} />
    <Route path={`${path}/lists`} render={() => framed(Lists)} />
    <Route path={`${path}/hero_component`} render={() => framed(HeroComponent)} />
    <Route path={`${path}/popovers`} render={() => framed(Popovers)} />
    <Route path={`${path}/tooltips`} render={() => framed(Tooltips)} />
    <Route path={`${path}/login`} render={() => framed(Login)} />
    <Route path={`${path}/icons`} render={() => framed(Icons)} />
    <Route path={`${path}/forms`} render={() => framed(Forms)} />
    <Route path={`${path}/time`} render={() => framed(Time)} />
    <Route path={`${path}/widgets`} render={() => framed(Widgets)} />
    <Route path={`${path}/navbar`} render={() => framed(NavbarSection)} />
    <Route path={`${path}/search`} render={() => framed(SearchSection)} />
    <Route path={`${path}/units`} render={() => framed(Units)} />
    <Route path={`${path}/navbar_demo`} component={NavbarDemo} />
    <Route path={`${path}/search_demo`} component={SearchDemo} />
    <Route path={`${path}/`} render={() => framed(Typography)} />
  </Switch>
);
